import * as APPCONFIG from "../config/app-config.js";
import auth from "./AuthAPI.js";
import Http from "./Http.js";

export const notificationsUnread = () => {
  return auth({
    method: "get",
    url: `${APPCONFIG.API_URL}api/notifications/unread`,
    headers: Http.AUTH_HEADERS(),
  });
};


export const markNotificationRead = (id) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/notifications/${id}/mark-read`,
    headers: Http.AUTH_HEADERS(),
  });
};

export const clearAllNotifications = () => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/notifications/mark-all-read`,
    headers: Http.AUTH_HEADERS(),
  });
};
